import React, { useState , useEffect} from 'react'
import { Link, useNavigate } from 'react-router-dom'
import "./PendingAdItem.css"

export default function PendingAdItem(props) {

  const [viewInfoButton, setViewInfoButton] = useState(true)
  const [notifi,setNotifi] = useState(false);

  useEffect(() => {
    if(props.displayInfo==="false"){
      setViewInfoButton(false);
    }
    if(props.notifi==="true")
      setNotifi(true);

  }, [])
  

  const navigate = useNavigate();

  const openNotifi = ()=>{
    navigate(`/dashboard/notifications/:${props.notifiId}`);
  }

  const openViewAd = ()=>{
    navigate(`/dashboard/viewAd/:${props.id}`);
  }

  return (
    <div className='pending-Ad-card'>
      <div className='pending-Ad-img-container'>
        <img src={props.img} alt="" className='pending-Ad-img' />
      </div>
      
      {props.isAdmin ?<div style={{color:'white',padding:"4% 1%"}}><b>Message from user:</b> {props.accepted?'AD Price Accepted by User':'Ad Price Rejected by User'}</div>:''}
      {viewInfoButton?(notifi?<button className='pendingviewAdBtn' onClick={openNotifi}> View Ad Info</button>: <button className='pendingviewAdBtn' onClick={openViewAd}> View Ad Info</button>):"" }
    </div>
  )
}
